import React from 'react';
import useSlider from '../utils/useSlider';

const Slider = ({ 
  id, 
  prevButtonId, 
  nextButtonId, 
  imageSelector, 
  autoSlideDelay = 5000,
  autoSlideEnabled = false, // Disable auto-sliding by default
  paddingOffset = 20,
  breakpoints,
  children 
}) => {
  const {
    sliderRef,
    slideToPrev,
    slideToNext,
    touchStart,
    touchMove,
    touchEnd,
    handleTransitionEnd
  } = useSlider({
    sliderId: id,
    imageSelector,
    defaultCardsPerView: 3,
    autoSlideDelay,
    autoSlideEnabled,
    paddingOffset,
    breakpoints
  });

  return (
    <>
      <div 
        id={id}
        ref={sliderRef}
        className="d-flex"
        style={{ cursor: 'grab' }}
        onMouseDown={touchStart}
        onMouseMove={touchMove}
        onMouseUp={touchEnd}
        onMouseLeave={touchEnd}
        onTouchStart={touchStart}
        onTouchMove={touchMove}
        onTouchEnd={touchEnd}
        onTransitionEnd={handleTransitionEnd}
        onContextMenu={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        {children}
      </div>
      {prevButtonId && (
        <div 
          id={prevButtonId}
          onClick={slideToPrev}
          className="slider-arrow prev"
        />
      )}
      {nextButtonId && (
        <div 
          id={nextButtonId}
          onClick={slideToNext}
          className="slider-arrow next"
        />
      )}
    </>
  );
};

export default Slider;
